/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cdo_Search_LabelInputs */

const vi_cdo_search_label = /** @type {(inputs: Cdo_Search_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tìm kiếm`)
};

/**

* @param {Cdo_Search_LabelInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const cdo_search_label = /** @type {((inputs?: Cdo_Search_LabelInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cdo_Search_LabelInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cdo_search_label(inputs)
});